import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "cf9651ce-dd3e-4e0b-b849-05e4e4df4ca9",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "number",
    shuffle: false,
    prefixText: "Ld(45°) =",
    suffixText: "dB",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 81.4,
};
